<div class="modal-header h4">
  <h5 class="modal-title text-center">Prise de contact</h5>
  <i aria-label="Close" (click)="handleClick(CLOSE)" class="close pull-right align-middle fas fa-times"> </i>
</div>
<form *ngIf="transportView" name="editForm" (ngSubmit)="handleSubmit()" autocomplete="off" class="p-2">
  <div class="d-flex flex-column justify-content-center align-items-center my-3">
    <span *ngIf="transportView.user?.companyName" class="font-weight-bold">{{ transportView.user?.companyName }}</span>
    <span>{{ transportView.user?.firstName }} {{ transportView.user?.lastName }}</span>
  </div>

  <div class="d-flex flex-row justify-content-center align-items-start my-3">
    <div class="mr-3">
      <i class="fas fa-phone fa-1x text-primary mr-2"></i>
      <span class="align-center">{{ transportView.user?.phone }}</span>
    </div>
    <div class="ml-3" [mdbTooltip]="'unvalidatedBaskets.modal.actions.contactCustomer' | translate" (click)="confirmedMailAfterGenerateEmail()">
      <i class="fas fa-envelope fa-1x text-primary mr-2"></i>
      <jhi-bary-mailto [isBtn]="false" [emailTransporter]="transportView.user?.email" [type]="LIST_MAILTO.ADD_DOCUMENT_DEFAULT_SENDING"> </jhi-bary-mailto>
    </div>
  </div>
  <div class="modal-footer justify-content-center flex-column">
    <div class="d-flex flex-row">
      <jhi-bary-input-checkbox
        class="mr-3"
        data-id-cypress="input-checkbox-call-phone"
        [control]="controls.confirmedPhone"
        [label]="'unvalidatedBaskets.modal.body.checkbox.label.confirmedPhone' | translate"
      ></jhi-bary-input-checkbox>
      <jhi-bary-input-checkbox
        class="ml-3"
        data-id-cypress="input-checkbox-send-mail"
        [control]="controls.confirmedMail"
        [label]="'unvalidatedBaskets.modal.body.checkbox.label.confirmedMail' | translate"
      ></jhi-bary-input-checkbox>
    </div>
    <jhi-bary-button class="my-2" data-id-cypress="validate-contact" type="submit" [label]="'BTN.CONFIRM' | translate"></jhi-bary-button>
  </div>
</form>
